import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import API from "../ApiService/ApiService";
import { styles } from "../ApiService/Data";

import { message, Form, Input, Select, Button } from "antd";

import SideBar from "./SideBar";

import {
  statesGetAllStart,
  statesGetAllSuccess,
  statesGetAllFail,
} from "../Redux/slices/states";
import {
  citiesGetAllStart,
  citiesGetAllSuccess,
  citiesGetAllFail,
} from "../Redux/slices/cities";
import {
  districtGetAllStart,
  districtGetAllSuccess,
  districtGetAllFail,
} from "../Redux/slices/district";
import { useSelector, useDispatch } from "react-redux";

const { Option } = Select;

const AddAddress = () => {
  const api = new API();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [district, setDistrict] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const dispatch = useDispatch();

  // console.log("selectedCountry", cities);

  useEffect(() => {
    getCountry();
    getDistrict();
    getCity();
    getState();
  }, [selectedCountry, selectedState, selectedDistrict]);

  const getCountry = () => {
    api.getCountry().then((res) => {
      // console.log("cntry",res?.data?.data);
      const arr = res?.data?.data?.filter((item) => (item?.status === true ? item : null));
      // console.log("cntry act",arr);     
      setCountries(arr);
    });
  };

  const getState = () => {
    api.getState(selectedCountry).then((res) => {
      const arr = res?.data?.data?.filter((item) => (item?.status === true ? item : null));
      setStates(arr);
    });
  };

  const getDistrict = () => {
    api.getdistrict(selectedState).then((res) => {
      const arr = res?.data?.data?.filter((item) => (item?.status === true ? item : null));
      setDistrict(arr);
    });
  };

  const getCity = () => {
    api.getArea(selectedDistrict).then((res) => {
      const arr = res?.data?.data?.filter((item) => (item?.status === true ? item : null));
      setCities(arr);
    });
  };

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
  };

  const handleDistrcitChange = (value) => {
    setSelectedDistrict(value);
  };

  const handleStateChange = (value) => {
    setSelectedState(value);
  };

  const addAddressForm = async (values) => {

    // values.buyer_country = countries?.find((item) => item?._id === values?.buyer_country)?.country;
    // values.buyer_state = states?.find((item) => item?._id === values?.buyer_state)?.state;
    // values.buyer_city = cities?.find((item) => item?._id === values?.buyer_city)?.area;

    // console.log("values->..................", values);
    const response = await api.createCommon("buyerbillingdetails", values);
    // console.log(response.response.data.message);
    if (response?.data?.success) {
      form.resetFields();
      message.success("Successfully Added");
      navigate("/delivery-address");
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  return (
    <React.Fragment>
      <Section>
        <Wrapper>
          <Title>Add Address</Title>
          <Align>
            <div>
              <SideBar />
            </div>
            <Right>
              <AddAddressSection>
                <Form
                  name="basic"
                  form={form}
                  onFinish={addAddressForm}
                  autoComplete="off"
                  layout="vertical"
                >
                  <Form.Item
                    label="Mobile Number"
                    name="buyer_delivery_contact_number"
                    rules={[
                      {
                        required: true,
                        pattern: /^[0-9]{10}$/,
                        message: "Please enter valid Mobile Number",
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                  <Form.Item
                    label="Alternate Mobile Number"
                    name="buyer_delivery_alternate_number"
                    rules={[
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Please enter valid Alternate Mobile Number",
                      }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Address 1"
                    name="buyer_address_line_1"
                    rules={[
                      {
                        required: true,
                        message: "Please input your address",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Address 2"
                    name="buyer_address_line_2"
                    rules={[
                      {
                        required: true,
                        message: "Please input your address",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Pincode"
                    name="buyer_pincode"
                    rules={[
                      {
                        required:true,
                        pattern: /^[1-9]\d{2}\s?\d{3}$/,
                        message:"Please Enter Valid Pincode"
                      }
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                  <Form.Item label="Landmark" name="landmark">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Country" name="buyer_country">
                    <Select
                      onChange={handleCountryChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {countries?.map((country) => (
                        <Option key={country?._id} value={country?._id}>
                          {country?.country}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="State"
                    name="buyer_state"
                    rules={[
                      {
                        required: true,
                        message: "Please select state",
                      },
                    ]}
                  >
                    <Select 
                    showSearch 
                    allowClear 
                    onChange={handleStateChange}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    >
                      {states?.map((state) => (
                        <Option key={state?._id} value={state?._id}>
                          {state?.state}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="District"
                    name="buyer_district"
                    rules={[
                      {
                        required: true,
                        message: "Please select District",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      onChange={handleDistrcitChange}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {district?.map((district) => (
                        // console.log("district--->", district),
                        <Option key={district?._id} value={district?._id}>
                          {district?.district}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="City"
                    name="buyer_city"
                    rules={[
                      {
                        required: true,
                        message: "Please select city",
                      },
                    ]}
                  >
                    <Select 
                    showSearch 
                    allowClear
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    >
                      {cities?.map((city) => (
                        <Option key={city?._id} value={city?._id}>
                          {city?.area}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" danger htmlType="submit">
                      Save Address
                    </Button>
                  </Form.Item>
                </Form>
              </AddAddressSection>
            </Right>
          </Align>
        </Wrapper>
      </Section>
    </React.Fragment>
  );
};

export default AddAddress;

const Section = styled.section`
  margin: 40px 0 60px 0;
  width: 100%;
  position: relative;
  display: inline-block;
`;
const Title = styled.h1`
  font-size: 30px;
  color: ${styles.color};
  margin: 0 0 20px 0;
`;
const Wrapper = styled.div`
  max-width: 1200px;
  padding: 0 10px;
  margin: auto;
`;
const Align = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;
`;
const Left = styled.div`
  width: 25%;
  display: inline-block;
  border: 1px solid ${styles.light};
  padding: 24px;
`;
const Right = styled.div`
  width: 72%;
  padding: 24px;
  display: inline-block;
  border: 1px solid ${styles.light};
`;

const AddAddressSection = styled.div`
  width: 100%;
  /*display: inline-block;
  position: relative;

  .ant-form-item:nth-child(odd) {
    width: 48%;
    display: flex;
    flex-direction: column;
    float: left;
  }
  .ant-form-item:nth-child(even) {
    width: 48%;
    display: flex;
    flex-direction: column;
    float: right;
  }
  .ant-form-item-label {
    width: 100%;
    display: inline-block;
    text-align: left;
  }
  .ant-row {
    flex-direction: column;
  } */
`;
